<div class="__left-container">
  <ng-content select="[left]"></ng-content>
</div>
<div class="__text-group">
  <h3 class="__main">{{mainText}}</h3>
  <span class="__sub">{{subText}}</span>
</div>
<div class="__right-container"
     (mouseover)="disableHostEvent(isRightClickable)"
     (mouseout)="enableHostEvent()">
  <ng-content select="[right]"></ng-content>
</div>

